//====================================================
//  Function: Gallery
//====================================================
function fn_components_gallery(){
	if ($( '.js-gallery' ).length){
		$( '.js-gallery' ).lightGallery({
			selector: '.js-gallery-item',
			hash: false
		})
	}

	// if ($( '.js-gallery-thumbnail' ).length){
	// 	$( '.js-gallery-thumbnail .js-gallery-thumbnail-item' ).on( 'click' , function () {
	// 		var inst = $(this);
	// 		var src = inst.find( 'img' ).attr( 'src' );
	// 		var gallery = inst.closest( '.js-gallery-click' );

	// 		gallery.find( '.js-gallery-main img' ).attr( 'src', src);
	// 		gallery.find( '.js-gallery-main .js-gallery-item' ).attr( 'href', src);

	// 	});
	// }
}